(function () {
// Uncomment the next lines to use your game instance in the browser
// const Game = require('../modules/Game.class');
// const game = new Game();
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    "use strict";
    function Game(initialState) {
        var _this = this;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.SIZE = 4;
        var empty = function() {
            return Array.from({
                length: _this.SIZE
            }, function() {
                return Array(_this.SIZE).fill(0);
            });
        };
        this._initial = initialState && initialState.length === this.SIZE ? initialState.map(function(r) {
            return r.slice();
        }) : empty();
        this.board = this._initial.map(function(r) {
            return r.slice();
        });
        this.score = 0;
        this.status = "idle";
        this._won = false;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            /** .
   *
   *
   *
   *
   *
   *                                                                  `
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]\
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ key: "moveLeft",
            value: function moveLeft() {
                return this._move("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                return this._move("right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                return this._move("up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                return this._move("down");
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board.map(function(r) {
                    return r.slice();
                });
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                if (this.status === "playing") return;
                this.board = this._initial.map(function(r) {
                    return r.slice();
                });
                this.score = 0;
                this.status = "playing";
                this._won = false;
                if (this._isEmptyBoard(this.board)) {
                    this._addRandomTile();
                    this._addRandomTile();
                }
                this._updateStatus();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.board = this._initial.map(function(r) {
                    return r.slice();
                });
                this.score = 0;
                this.status = "idle";
                this._won = false;
            }
        },
        {
            key: "_isEmptyBoard",
            value: function _isEmptyBoard(b) {
                return b.flat().every(function(v) {
                    return v === 0;
                });
            }
        },
        {
            key: "_move",
            value: function _move(direction) {
                if (this.status !== "playing") return false;
                var prevState = this.getState();
                switch(direction){
                    case "left":
                        this._moveLeftImpl();
                        break;
                    case "right":
                        this._moveRightImpl();
                        break;
                    case "up":
                        this._moveUpImpl();
                        break;
                    case "down":
                        this._moveDownImpl();
                        break;
                    default:
                        return false;
                }
                var changed = !this._boardsEqual(prevState, this.board);
                if (changed) {
                    this._addRandomTile();
                    this._updateStatus();
                }
                this._updateStatus();
                if (!this._hasMoves() && this.status === "playing") this.status = "lose";
                return changed;
            }
        },
        {
            key: "_boardsEqual",
            value: function _boardsEqual(a, b) {
                return a.flat().every(function(v, i) {
                    return v === b.flat()[i];
                });
            }
        },
        {
            key: "_addRandomTile",
            value: function _addRandomTile() {
                var empties = [];
                for(var r = 0; r < this.SIZE; r++){
                    for(var c = 0; c < this.SIZE; c++)if (this.board[r][c] === 0) empties.push([
                        r,
                        c
                    ]);
                }
                if (empties.length === 0) return;
                var _empties_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(empties[Math.floor(Math.random() * empties.length)], 2), rr = _empties_Math_floor[0], cc = _empties_Math_floor[1];
                this.board[rr][cc] = Math.random() < 0.1 ? 4 : 2;
            }
        },
        {
            key: "_updateStatus",
            value: function _updateStatus() {
                if (!this._won && this._hasTarget(2048)) {
                    this.status = "win";
                    this._won = true;
                    return;
                }
                if (this._hasMoves()) {
                    if (this.status !== "win") this.status = "playing";
                    return;
                }
                if (this.status !== "idle") this.status = "lose";
            }
        },
        {
            key: "_hasTarget",
            value: function _hasTarget(val) {
                return this.board.flat().includes(val);
            }
        },
        {
            key: "_hasMoves",
            value: function _hasMoves() {
                for(var r = 0; r < this.SIZE; r++)for(var c = 0; c < this.SIZE; c++){
                    var v = this.board[r][c];
                    if (v === 0) return true;
                    if (r + 1 < this.SIZE && this.board[r + 1][c] === v) return true;
                    if (c + 1 < this.SIZE && this.board[r][c + 1] === v) return true;
                }
                return false;
            }
        },
        {
            key: "_moveLeftImpl",
            value: function _moveLeftImpl() {
                var _this = this, _loop = function(r) {
                    var row = _this.board[r].filter(function(v) {
                        return v !== 0;
                    });
                    var merged = [];
                    for(var i = 0; i < row.length; i++){
                        var curr = row[i];
                        var next = row[i + 1];
                        if (next && curr === next) {
                            var nv = curr * 2;
                            merged.push(nv);
                            gained += nv;
                            i++;
                        } else merged.push(curr);
                    }
                    while(merged.length < _this.SIZE)merged.push(0);
                    _this.board[r] = merged;
                };
                var gained = 0;
                for(var r = 0; r < this.SIZE; r++)_loop(r);
                this.score += gained;
            }
        },
        {
            key: "_moveRightImpl",
            value: function _moveRightImpl() {
                this.board = this.board.map(function(row) {
                    return row.slice().reverse();
                });
                this._moveLeftImpl();
                this.board = this.board.map(function(row) {
                    return row.slice().reverse();
                });
            }
        },
        {
            key: "_moveUpImpl",
            value: function _moveUpImpl() {
                this.board = this._transpose(this.board);
                this._moveLeftImpl();
                this.board = this._transpose(this.board);
            }
        },
        {
            key: "_moveDownImpl",
            value: function _moveDownImpl() {
                this.board = this._transpose(this.board);
                this._moveRightImpl();
                this.board = this._transpose(this.board);
            }
        },
        {
            key: "_transpose",
            value: function _transpose(b) {
                return b[0].map(function(_, c) {
                    return b.map(function(r) {
                        return r[c];
                    });
                });
            }
        }
    ]);
    return Game;
}();
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$cells = Array.from(document.querySelectorAll(".field-cell"));
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$btn = document.querySelector(".button");
var $197cd56b15c33885$var$msgStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$msgWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$msgLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$field = document.querySelector(".game-field");
var $197cd56b15c33885$var$cellIndex = function(r, c) {
    return r * 4 + c;
};
function $197cd56b15c33885$var$render() {
    var state = $197cd56b15c33885$var$game.getState();
    for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
        var i = $197cd56b15c33885$var$cellIndex(r, c);
        var el = $197cd56b15c33885$var$cells[i];
        var val = state[r][c];
        el.textContent = val === 0 ? "" : String(val);
        el.className = "field-cell";
        if (val) el.classList.add("field-cell--".concat(val));
    }
    $197cd56b15c33885$var$scoreEl.textContent = String($197cd56b15c33885$var$game.getScore());
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    if (gameStatus === "idle") {
        $197cd56b15c33885$var$msgStart.classList.remove("hidden");
        $197cd56b15c33885$var$msgWin.classList.add("hidden");
        $197cd56b15c33885$var$msgLose.classList.add("hidden");
        $197cd56b15c33885$var$btn.textContent = "Start";
        $197cd56b15c33885$var$btn.classList.add("start");
        $197cd56b15c33885$var$btn.classList.remove("restart");
    } else {
        $197cd56b15c33885$var$msgStart.classList.add("hidden");
        $197cd56b15c33885$var$btn.textContent = "Restart";
        $197cd56b15c33885$var$btn.classList.remove("start");
        $197cd56b15c33885$var$btn.classList.add("restart");
    }
    if (gameStatus === "win") $197cd56b15c33885$var$msgWin.classList.remove("hidden");
    else $197cd56b15c33885$var$msgWin.classList.add("hidden");
    if (gameStatus === "lose") $197cd56b15c33885$var$msgLose.classList.remove("hidden");
    else $197cd56b15c33885$var$msgLose.classList.add("hidden");
}
$197cd56b15c33885$var$btn.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$render();
});
document.addEventListener("keydown", function(e) {
    var key = e.key;
    if (![
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return;
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    e.preventDefault();
    var moved = false;
    switch(key){
        case "ArrowLeft":
            moved = $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            break;
    }
    if (moved) $197cd56b15c33885$var$render();
});
var $197cd56b15c33885$var$startX = 0;
var $197cd56b15c33885$var$startY = 0;
function $197cd56b15c33885$var$lockPageScroll() {
    document.body.classList.add("no-scroll");
}
function $197cd56b15c33885$var$unlockPageScroll() {
    document.body.classList.remove("no-scroll");
}
$197cd56b15c33885$var$field.addEventListener("mousedown", function(e) {
    $197cd56b15c33885$var$startX = e.clientX;
    $197cd56b15c33885$var$startY = e.clientY;
});
$197cd56b15c33885$var$field.addEventListener("mouseup", function(e) {
    $197cd56b15c33885$var$handleSwipe(e.clientX - $197cd56b15c33885$var$startX, e.clientY - $197cd56b15c33885$var$startY);
});
$197cd56b15c33885$var$field.addEventListener("touchstart", function(e) {
    var touch = e.changedTouches[0];
    e.preventDefault();
    $197cd56b15c33885$var$startX = touch.clientX;
    $197cd56b15c33885$var$startY = touch.clientY;
    $197cd56b15c33885$var$lockPageScroll();
}, {
    passive: false
});
$197cd56b15c33885$var$field.addEventListener("touchmove", function(e) {
    e.preventDefault();
}, {
    passive: false
});
$197cd56b15c33885$var$field.addEventListener("touchend", function(e) {
    var touch = e.changedTouches[0];
    e.preventDefault();
    $197cd56b15c33885$var$handleSwipe(touch.clientX - $197cd56b15c33885$var$startX, touch.clientY - $197cd56b15c33885$var$startY);
    $197cd56b15c33885$var$unlockPageScroll();
}, {
    passive: false
});
$197cd56b15c33885$var$field.addEventListener("touchcancel", function() {
    $197cd56b15c33885$var$unlockPageScroll();
});
function $197cd56b15c33885$var$handleSwipe(dx, dy) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    if (Math.abs(dx) < 30 && Math.abs(dy) < 30) return;
    var moved = false;
    if (Math.abs(dx) > Math.abs(dy)) moved = dx > 0 ? $197cd56b15c33885$var$game.moveRight() : $197cd56b15c33885$var$game.moveLeft();
    else moved = dy > 0 ? $197cd56b15c33885$var$game.moveDown() : $197cd56b15c33885$var$game.moveUp();
    if (moved) $197cd56b15c33885$var$render();
}
$197cd56b15c33885$var$render();

})();
//# sourceMappingURL=index.d7fb0e84.js.map
